import React from "react";
import { Modal } from "antd";
import styles from "./style.module.css";
import { warningTeacher, warningStudent } from "../../services/auth";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import "./style.css";
import { set } from "date-fns";

const WarningModal = ({ isModalVisible, setIsModalVisible, data, role }) => {
  const [warning, setWarning] = useState("");
  const [type, setType] = useState("Info");
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const warningPost = async (id) => {
    const body = {
      content: warning,
      type: type,
    };
    try {
      const res =
        role === "student"
          ? await warningStudent(id, body)
          : await warningTeacher(id, body);
      console.log(res);
      toast.success("Warning send Successfully");
      handleOk();
    } catch {
      toast.error("Warning not send");
      console.log("Error Waring Api");
    }
  };

  return (
    <>
      <Toaster />
      <Modal
        title="Warning"
        footer={null}
        closable
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={600}
        style={{
          top: 150,
        }}
      >
        <div className="row px-1">
          <div className="form-group">
            <textarea
              className={`form-control shadow ${styles.border_color} mt-2`}
              id="exampleFormControlTextarea1"
              rows="4"
              value={warning}
              onChange={(e) => {
                setWarning(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="dropdown">
            <button
              className="btn btn-sm btn_contained_black fs_12 text-white dropdown-toggle"
              // type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              // defaultValue={info}
            >
              {type}
            </button>
            <ul className="dropdown-menu fs_12">
              {["Info", "Warning", "Block"].map((item) => (
                <li key={item}>
                  <a
                    className="dropdown-item"
                    href="#!"
                    onClick={() => setType(item)}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="text-right">
            <button
              onClick={handleCancel}
              className="btn btn_outlined fs_12 btn-sm text-danger px-3 py-1 mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn_contained_black fs_12 btn-sm text-white px-3 py-1"
              onClick={() => {
                warningPost(data.id);
              }}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WarningModal;
